import { Employee } from '../types';

export const formatName = (employee: Employee): string => {
  if (!employee?.user?.last_name && !employee?.user?.first_name) {
    return `${employee?.user?.first_name}` || 'Unknown.';
  }
  return `${employee?.user?.last_name}, ${employee.user?.first_name}`;
};
